import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function ArticlePreview() {
  const primaryArticles = articles.slice(0, 3);
  const secondaryArticles = articles.slice(3);

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-screen-2xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Latest
            <br />
            SEO Resources
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-lg">
            In-depth acbuyspreadsheet guides and articles written to help you master product sourcing
            and make informed buying decisions through our comprehensive spreadsheet resources.
          </p>
        </div>

        {/* Top 3 Featured */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-8">
          {primaryArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-accent-300/60 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/10] w-full overflow-hidden bg-background-100">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-6 flex flex-col gap-2 flex-1">
                <span className="text-xs font-medium text-accent-500 uppercase tracking-wider">
                  {article.tag}
                </span>
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="mt-auto pt-3 text-sm font-medium text-accent-600 group-hover:text-accent-700 transition-colors flex items-center gap-1 whitespace-nowrap">
                  Read Full Guide
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>

        {/* Remaining 9 Articles Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {secondaryArticles.map((article, idx) => (
            <Link
              key={article.slug}
              to={`/${article.slug}`}
              className="group bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden hover:border-secondary-300/60 transition-all duration-300 cursor-pointer flex flex-col"
            >
              <div className="aspect-[16/10] w-full overflow-hidden bg-background-100">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5 md:p-5 flex flex-col gap-2 flex-1">
                <span className={`text-xs font-medium uppercase tracking-wider ${idx % 3 === 0 ? "text-accent-500" : "text-secondary-500"}`}>
                  {article.tag}
                </span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-accent-600 transition-colors leading-snug">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {article.excerpt}
                </p>
                <span className="mt-auto pt-2 text-sm font-medium text-secondary-600 group-hover:text-secondary-700 transition-colors flex items-center gap-1 whitespace-nowrap">
                  Read Article
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}